/*
 * Defines a new function that formats numbers by specifying the number of decimal digits
 * and the thousand separator
 * n -> spcifies the number of digits after the decimal separator
 * x -> defines the number of digits required for the comma (,) separator
 * Example...
 * 
 * 12345.678.format(2,3) formats the number as 12, 345.68
 */
Number.prototype.format = function (n, x) {
    var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
    return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
};